<template>
  <el-card>
    <template #header>
      <div class="header-class">
        <div>
          <content-header />
        </div>
        <div class="wid-class">
          <span>待处理数:</span><span class="font-col">{{ waitNumbers }}</span>
        </div>
      </div>
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="users"
      style="font-size:12px;"
      resource="user"
    >
        <!--      <el-table-column-->
        <!--        label="头像"-->
        <!--        align="center"-->
        <!--        min-width="100"-->
        <!--      >-->
        <!--        <template slot-scope="scope">-->
        <!--          <img-->
        <!--            :src="scope.row.user.avatar"-->
        <!--            min-width="30"-->
        <!--            height="30"-->
        <!--          >-->
        <!--        </template>-->
        <!--      </el-table-column>-->
        <el-table-column
        prop="user.nickname"
        show-overflow-tooltip
        label="真实姓名"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          {{scope.row.user.truename}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="user.mobile"
        label="手机号码"
        align="center"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        label="认证类型"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.type==1"
            type="success"
            size="mini"
            plain
          >
            {{ scope.row.type_text }}
          </el-button>
          <el-button
            v-if="scope.row.type==0"
            type="danger"
            size="mini"
            plain
          >
            {{ scope.row.type_text }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="school"
        align="center"
        label="学校"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="student_no"
        align="center"
        label="学号或工号"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="year"
        label="年份"
        show-overflow-tooltip
        align="center"
        min-width="120"
      />

      <el-table-column
        prop="register_area"
        label="所属区域"
        show-overflow-tooltip
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="created_at"
        align="center"
        show-overflow-tooltip
        min-width="120"
        label="申请时间"
      />
      <el-table-column
        label="审核状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.auth_status==1"
            type="success"
            size="mini"
            plain
          >
            {{ scope.row.auth_status_text }}
          </el-button>
          <el-button
            v-if="scope.row.auth_status==0"
            type="danger"
            size="mini"
            plain
          >
            {{ scope.row.auth_status_text }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="error_msg"
        label="失败原因"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            @click="authClick(scope.row)"
            type="primary"
            size="mini"
          >设置</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-dialog
      title="认证信息"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <el-card
        class="box-card"
        style="display: inline-block;width: 45%;margin-right: 20px;"
      >
        <div
          slot="header"
          class="clearfix"
        >
          <span>认证信息</span>
        </div>
        <div>
          <span class="label-name"> 姓名: </span> <span>{{ editStudent.name }}</span>
        </div>
        <div>
          <span class="label-name"> 类型: </span> <span>{{ editStudent.type_text }}</span>
        </div>
        <div>
          <span class="label-name"> 学校: </span> <span>{{ editStudent.school }}</span>
        </div>
        <div>
          <span class="label-name"> 学号: </span> <span>{{ editStudent.student_no }}</span>
        </div>
        <div>
          <span class="label-name"> 入学年份: </span> <span>{{ editStudent.year }}</span>
        </div>
        <div>
          <span class="label-name"> 上传凭证: </span> <span>
            <el-image
              style="width: 100px; height: 100px"
              :src="editStudent.resource.url"
              :preview-src-list="[editStudent.resource.url]"
              v-if="dialogVisible"
            >
            </el-image>
          </span>
        </div>
      </el-card>

      <el-card
        class="box-card"
        style="display: inline-block;width: 50%;vertical-align: top;"
      >
        <div
          slot="header"
          class="clearfix"
        >
          <span>认证结果</span>
        </div>
        <el-form
          ref="formAuth"
          :model="formAuth"
          :rules="formRules"
          label-width="150px"
        >
          <el-form-item
            prop="auth_status"
            required
            label="认证状态"
          >
            <el-select
              class="limit-width"
              v-model="formAuth.auth_status"
              placeholder="请选择"
            >
              <el-option
                v-for="item in auth_status"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            prop="auth_date"
            label="认证过期时间"
          >
            <el-date-picker
              v-model="formAuth.auth_date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择失效时间"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            prop="error_msg"
            label="失败信息"
          >
            <el-input
              type="textarea"
              v-model="formAuth.error_msg"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submit()"
            >确 定</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getStudents, getUserStuentNumber, editStudents } from "@/api/users";
import { mixinsAutoPageSize, isAdministrator, can } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Student",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          field: "truename",
          label: "真实姓名"
        },
        {
          type: "el-select",
          field: "is_card_certified",
          label: "实名认证状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: "0",
              label: "未实名"
            },
            {
              value: "1",
              label: "已实名"
            }
          ]
        },
        {
          type: "el-select",
          field: "status",
          label: "使用状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: "0",
              label: "暂停使用"
            },
            {
              value: "1",
              label: "正常"
            }
          ]
        }
      ],
      users: [],
      page: null,
      waitNumbers: 0,
      editStudent: [],
      auth_status: [
        {
          id: 0,
          title: "待认证"
        },
        {
          id: 1,
          title: "认证成功"
        },
        {
          id: 2,
          title: "认证失败"
        }
      ],
      formAuth: {
        id: 0,
        auth_status: 0,
        auth_date: "",
        error_msg: ""
      },
      dialogVisible: false,
      formRules: {
        auth_status: [
          { required: true, message: "请选择认证结果", trigger: "change" }
        ]
      }
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],

  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(57, newVal);

        const {
          data: { data, meta }
        } = await getStudents(newVal.query);
        this.users = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    this.balanceShow = !can("rechargeBalance");
    this.returnBalanceShow = can("returnBalance");

    const { data: number } = await getUserStuentNumber();
    this.waitNumbers = number;
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[4].options.push.apply(
          this.search[4].options,
          merchant.data
        );
      }
    }
  },
  methods: {
    authClick(row) {
      this.editStudent = row;
      this.dialogVisible = true;
      this.formAuth.id = row.id;
    },
    submit() {
      console.log("mead");
      this.$refs["formAuth"].validate(valid => {
        if (valid) {
          if (this.formAuth.auth_status == 1) {
            if (!this.formAuth.auth_date) {
              alert("请输入到期时间");
              return false;
            }
          } else {
            if (!this.formAuth.error_msg) {
              alert("请输入失败原因");
              return false;
            }
          }
          editStudents(this.formAuth).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisibleActive = false;
                this.formAuth.auth_status = 0;
                this.formAuth.id = 0;
                this.formAuth.error_msg = "";
                this.formAuth.auth_date = "";
              }
            });
          });
        } else {
          alert("请检查输入内容");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.label-name {
  text-align: right;
  // float: left;
  display: inline-block;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  width: 100px;
  padding: 0 12px 0 0;
  // -webkit-box-sizing: border-box;
  // box-sizing: border-box;
}

.textarea-class {
  display: inline-block;
  width: 300px;
}

.header-class {
  display: flex;
  justify-content: space-between;

  .wid-class {
    width: 250px;
    text-align: right;

    span {
      padding-right: 10px;
    }

    .font-col {
      color: rgb(216, 24, 24);
    }
  }
}
</style>
